import { combineReducers } from 'redux-immutable'
import timesheetGetReducer from './timesheet-get-reducer'
import myTimesheetGetReducer from './my-timesheet-get-reducer'
import timesheetEditReducer from './timesheet-edit-reducer'
import myTimesheetSetInvalidInputReducer from './my-timesheet-set-invalid-input-reducer'
import timesheetByProjectsGetReducer from './timesheet-get-projects-reducer'
import timesheetSubmitReducer from './timesheet-submit-reducer'
import timesheetStatusGetReducer from './timesheet-status-get-reducer'
import timesheetRequestGetReducer from './timesheet-request-get-reducer'
import timesheetRedirectReducer from './timesheet-redirect-reducer'
import timesheetApproveReducer from './timesheet-approve-reducer'
import timesheetExportReducer from './timesheet-export-reducer'
import timesheetCancelReducer from './timesheet-cancel-reducer'
import myTimesheetExportReducer from './my-timesheet-export-reducer'
import timesheetManualReducer from './timesheet-manual-reducer'
import timesheetSetOptionsReducer from './timesheet-set-options-reducer'

export default combineReducers({
  timesheetGet: timesheetGetReducer,
  myTimesheetGet: myTimesheetGetReducer,
  timesheetEdit: timesheetEditReducer,
  myTimesheetSetInvalidInput: myTimesheetSetInvalidInputReducer,
  timesheetByProjectsGet: timesheetByProjectsGetReducer,
  timesheetSubmit: timesheetSubmitReducer,
  timesheetStatusGet: timesheetStatusGetReducer,
  timesheetRequestGet: timesheetRequestGetReducer,
  timesheetRedirect: timesheetRedirectReducer,
  timesheetApprove: timesheetApproveReducer,
  timesheetExport: timesheetExportReducer,
  timesheetCancel: timesheetCancelReducer,
  myTimesheetExport: myTimesheetExportReducer,
  timesheetManual: timesheetManualReducer,
  timesheetSetOptions: timesheetSetOptionsReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/timesheet/index.js